import { render, staticRenderFns } from "./home-model.vue?vue&type=template&id=de56bc6a&scoped=true&"
import script from "./home-model.vue?vue&type=script&lang=js&"
export * from "./home-model.vue?vue&type=script&lang=js&"
import style0 from "./home-model.vue?vue&type=style&index=0&id=de56bc6a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de56bc6a",
  null
  
)

export default component.exports